import { render } from "./telegramIntegration.vue?vue&type=template&id=58a04e3a"
import script from "./telegramIntegration.vue?vue&type=script&lang=js"
export * from "./telegramIntegration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__